import { styled } from "styled-components";

export const PageHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
    padding-bottom:3rem;

	.form-group {
		color: #555;
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		gap: 1rem;
        

		label {
			color: #333;
			font-weight: 400;
			font-size: 1rem;
            font-weight: 500;
		}

		select.edit{
			padding: 8px 14px;
			border-radius: 6px;
			border: 1px solid #b8c8cf;
            color: #333;
		}

	}
`;
